<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconLeave_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M15.787 2H7.213A3.217 3.217 0 0 0 4 5.213v5.537h6.984L9.561 7.885a.814.814 0 0 1 .253-1.022.82.82 0 0 1 1.049.085l4.476 4.476a.814.814 0 0 1 0 1.15l-4.476 4.476a.813.813 0 0 1-1.302-.937l1.423-2.865H4v5.537A3.217 3.217 0 0 0 7.213 22h8.574A3.217 3.217 0 0 0 19 18.787V5.213A3.217 3.217 0 0 0 15.787 2"
    />
</svg>
